import { Component, Inject, Input, OnDestroy } from '@angular/core';

import { ApplicationFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'rwidget-journey-planner-filter-transport-mode',
    templateUrl: './journey-planner-filter-transport-mode.component.html',
    styleUrls: ['./journey-planner-filter-transport-mode.component.scss']
})
export class JourneyPlannerFilterTransportModeComponent extends BaseComponent implements OnDestroy {
    @Input() values: Array<string>;
    @Input() formGroup: FormGroup;

    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade
    ) {
        super();
    }

    itemClick(event, value) {
        const formValue = this.formGroup.get('transportModes').value;

        if (formValue.length === 1 && formValue[0] === value) {
            event.stopPropagation();
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
